export default __webpack_public_path__ + "static/media/phone2body.d214c518.svg";